import { get } from '../Services/http';
import { catchError } from './Error.action';

export const PRODUCT_CONFIGURATOR_LOAD = 'PRODUCT_CONFIGURATOR_LOAD';
export const PRODUCT_CONFIGURATOR_LOAD_ERROR = 'PRODUCT_CONFIGURATOR_LOAD_ERROR';
export const PRODUCT_CONFIGURATOR_RECEIVE = 'PRODUCT_CONFIGURATOR_RECEIVE';

export const load = (baseProductId) => (dispatch, getState) => {
    var url = '/api/productConfiguration/forBaseProduct';
    url += '?baseProductId=' + encodeURIComponent(baseProductId);
    return get(url)
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: PRODUCT_CONFIGURATOR_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {
    return ({
        type: PRODUCT_CONFIGURATOR_RECEIVE,
        payload: {
            articles: data.configurationSection,
            emptyArticles: data.emptyConfigurationSection,
        },
    });
}

// Products sold in packs (2-pack, 4-pack, ...) step a whole pack at a time. The pack size
// belongs to the selected variant, so it can change when the customer picks another variant.
export const getPackSize = (article) => {
    var variant = article.configVariants.find(x => x.sku == article.defaultVariant) || article.configVariants[0];
    return Math.max(1, (variant && variant.packSize) || 1);
}

export const increment = (articleId) => (dispatch, getState) => {
    var articles = getState().articles.articles.slice();
    var emptyArticles = getState().articles.emptyArticles.slice();
    var article = articles.find(elem => elem.defaultVariant == articleId);
    article.defaultAmmount += getPackSize(article);
    return dispatch(receive({ configurationSection: articles, emptyConfigurationSection: emptyArticles }));
}

export const decrement = (articleId) => (dispatch, getState) => {
    var articles = getState().articles.articles.slice();
    var emptyArticles = getState().articles.emptyArticles.slice();
    var article = articles.find(elem => elem.defaultVariant == articleId);
    if (article.defaultAmmount > 0) {
        article.defaultAmmount = Math.max(0, article.defaultAmmount - getPackSize(article));
    }
    return dispatch(receive({ configurationSection: articles, emptyConfigurationSection: emptyArticles }));
}

export const changeVariant = (oldId, newId) => (dispatch, getState) => {
    var articles = getState().articles.articles.slice();
    var emptyArticles = getState().articles.emptyArticles.slice();
    var article = articles.find(elem => elem.defaultVariant == oldId);
    article.defaultVariant = newId;
    // The new variant can have another pack size; keep the amount a whole number of packs.
    var packSize = getPackSize(article);
    if (article.defaultAmmount > 0) {
        article.defaultAmmount = Math.ceil(article.defaultAmmount / packSize) * packSize;
    }
    return dispatch(receive({ configurationSection: articles, emptyConfigurationSection: emptyArticles }));
}